import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'reactstrap'
import { downloadFile } from '../../api/globalFunctions'
import { ImagesActionsProps } from './types'

// action buttons: editor close, selectAll, delete, download
const ImagesActions = (props: ImagesActionsProps) => {
    const { t } = useTranslation()

    const { imageData, editorImage, selectedImagesIds, setEditorImage, handleSelectAll, handleImagesDelete } = props

    const handleImagesDownload = async () => {
        const selectedImages = imageData.filter((file) => selectedImagesIds?.includes(file.id.toString()))
        const fileName = selectedImages.length > 1 ? 'photos.zip' : selectedImages[0].fileName
        const ids = selectedImagesIds.join(',')

        await downloadFile(ids, fileName)
    }

    return (
        <div className="hstack gap-2 d-print-none">
            {editorImage && (
                <Button onClick={() => setEditorImage(null)} color="dark" className="btn-icon" style={{ zIndex: 2 }} data-testid="close-button">
                    <i className="mdi mdi-close" />{' '}
                </Button>
            )}
            {imageData?.length > 0 && (
                <Button color="warning" className="btn-label" disabled={!!editorImage} onClick={handleSelectAll}>
                    <i className="mdi mdi-checkbox-multiple-outline label-icon align-middle fs-16 me-2"></i>{' '}
                    {selectedImagesIds.length ? t('button.deselect') : t('button.select')}
                </Button>
            )}
            {selectedImagesIds.length ? (
                <>
                    <Button
                        color="danger"
                        className="btn-label"
                        disabled={!!editorImage && !selectedImagesIds.length}
                        onClick={() => handleImagesDelete()}
                    >
                        <i className="mdi mdi-trash-can-outline label-icon align-middle fs-16 me-2"></i> {t('button.delete')}
                    </Button>
                    <Button onClick={handleImagesDownload} color="edit" className="btn-label" disabled={!!editorImage && !selectedImagesIds.length}>
                        <i className="mdi mdi-download label-icon align-middle fs-16 me-2"></i>
                        {t('button.download')}
                    </Button>
                </>
            ) : null}
        </div>
    )
}

export default memo(ImagesActions)
